<template>
	<div class="w-100 topDiv" :class="applyStyles ? '' : 'd-flex align-items-center justify-content-between'">
		<label id="hideinmobile" v-if="!noLabel" class="teams-label-font w-40"
			>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
		>
		<!-- :class="
                $v.profile.phoneNumber.$error || invalidPhone
                    ? 'phonenumber-error'
                    : 'phonenumber-input'
            " -->
		<div class="w-100 d-flex align-items-center position-relative pl-0">
			<div class="floating-label">
				<b-form-input
					:disabled="computedDisabled"
					:id="id"
					class="teams-inputField"
					:type="localType"
					:placeholder="placeholder"
					v-model.trim="inputData"
					@keydown="restrictInput"
					@keyup="restrictInput"
					@input="handleInput()"
					@blur="$emit('handle-blur')"
					no-wheel
					:class="{ error: showError, activateEmail: applyStyles }"
					@keypress="id == 'totalYearsOfExp' ? numbersOnly() : ''"
				></b-form-input>
				<label id="hideinlaptop" :class="{ active: isFocused || (inputData !== '' && inputData !== null && inputData !== undefined) }"
					>{{ label
					}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "input",
	data() {
		return {
			inputData: "",
			isFocused: false,
			decimalFields: [
				"currentCTC",
				"expectedCTC",
				"experince",
				"gradePercentage",
			],
			localType: "",
		};
	},
	props: {
		noLabel: Boolean,
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		fieldType: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	watch: {
		vmodel(newValue) {
			this.inputData = newValue;
			console.log("the new value", newValue);
			this.handleInput();
		},
	},

	created() {
		if (this.vmodel || (this.vmodel !== null && this.id == "totalYearsOfExp")) {
			this.inputData = this.vmodel;
			this.$emit("select-value", this.inputData);
		}
		if (this.id == "gradePercentage") {
			this.localType = "text";
		} else {
			this.localType = this.type;
		}
	},
	computed: {
		computedDisabled() {
			return (
				this.disabled || (this.fieldType == "default" && this.type === "email")
			);
		},
		applyStyles(){
			return this.id == 'activate-email';
		}
	},
	methods: {
		numbersOnly(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				charCode > 31 &&
				(charCode < 48 || charCode > 57) &&
				charCode !== 46
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},

		restrictInput(event) {
			console.log("input restrict", this.type, this.id);
			if (this.type == "number") {
				const charCode = event.key;
				// Check if the input should allow decimals or not
				if (
					(this.id === "phoneNumber" || this.id === "altPhoneNumber") &&
					event.target.value.length >= 10 &&
					event.key !== "Backspace"
				) {
					if (
						!(
							event.ctrlKey &&
							(charCode == "a" ||
								charCode == "c" ||
								charCode == "v" ||
								charCode == "x")
						) &&
						event.type !== "paste"
					) {
						event.preventDefault();
						return;
					}
				}
				var allowDecimal = this.decimalFields.includes(this.id);
				console.log("allowDecimal", allowDecimal);
				if (!allowDecimal) {
					if (charCode === ".") {
						event.preventDefault();
					}
				}
				if (charCode == "+" || charCode == "-" || charCode == "e") {
					event.preventDefault();
				}
				// Replace characters based on whether decimals are allowed
				if (allowDecimal) {
					if (this.id == "gradePercentage") {
						let value = event.target.value;
						let key = event.key;

						if (
							key === "Backspace" ||
							key === "Delete" ||
							key === "ArrowLeft" ||
							key === "ArrowRight"
						) {
							return;
						}

						if (key === "." && value.includes(".")) {
							event.preventDefault();
							return;
						}

						if (!/\d/.test(key) && key !== ".") {
							event.preventDefault();
							return;
						}

						let newValue = value + key;

						let regex = /^\d{1,3}(\.\d{0,2})?$/;

						if (!regex.test(newValue)) {
							event.preventDefault();
							return;
						}

						if (
							parseFloat(newValue) > 100 ||
							(parseFloat(newValue) == 100 && key == ".")
						) {
							event.preventDefault();
						}
					} else if (this.id == "experince" || this.id == "expectedCTC" || this.id == "currentCTC") {
						let key = event.key;
						if (
							key == "ArrowUp" ||
							key == "ArrowDown" ||
							event.type == "paste"
						) {
							event.preventDefault();
							return;
						}
					} else if (this.inputData) {
						let afterDecimal = this.inputData.split(".")[1];
						if (
							afterDecimal.length >= 2 &&
							event.key !== "Backspace" &&
							!(
								event.ctrlKey &&
								(charCode == "a" || charCode == "c" || charCode == "v")
							) &&
							event.type !== "paste"
						) {
							event.preventDefault();
						}
					}

					// Allow digits, dot (.), but disallow 'e', '+', '-'
					this.inputData = this.inputData.replace(/[^\d.]/g, "");

					// Ensure no more than one decimal point
					this.inputData = this.inputData.replace(/(\..*)\./g, "$1");

					// Ensure no more than two digits after the decimal point
					this.inputData = this.inputData.replace(/(\.\d{2})\d+/g, "$1");
				} else {
					this.inputData = this.inputData.replace(/[^\d]/g, ""); // Only allow digits
				}

				// Remove extra decimal points
				this.inputData = this.inputData.replace(/(\..*)\./g, "$1");
				this.$forceUpdate();
				this.handleInput();
			}
		},
		handleInput() {
			if (this.type === "email") {
				this.inputData = this.inputData.toLowerCase();
			}
			this.$emit("select-value", this.inputData);
			this.$emit("handle-input");
		},
	},
};
</script>

<style scoped>
/* Hide number icon */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input[type="number"] {
	-moz-appearance: textfield;
	appearance: textfield;
}

.topDiv .error {
	border: 1px solid red !important;
}

.activateEmail{
	height: 30px !important;
	background: #4A73D212;
	border: 1px solid #85A1E0 !important;
}
</style>
